import { Button, Form, Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import {
  getEPIPorGrupo,
  getEPI,
  emptyRelacaoEPISelecionanda,
  getEPIsPorGrupo,
} from "../../actions";
import "../../../styles.scss";

const { Option } = Select;

const EPIList = (props) => {
  const [riskFactorList, setRiskFactorList] = useState([]);

  const handleGroupSelection = async (value) => {
    let riskFactorByGroup = await getEPIsPorGrupo(value);
    setRiskFactorList(riskFactorByGroup);
  };

  const handleEdit = (id) => {
    emptyRelacaoEPISelecionanda(props.dispatch);
    getEPI(id, props.dispatch);
  };

  return (
    <React.Fragment>
      <div>
        <div>
          <Select
            style={{
              width: 250,
            }}
            placeholder="Selecione um grupo de risco"
            onSelect={(value) => handleGroupSelection(value)}
          >
            <Option value="1">Físico</Option>
            <Option value="2">Químico</Option>
            <Option value="3">Biológico</Option>
            <Option value="4">Ergonômico</Option>
            <Option value="5">Acidente</Option>
            <Option value="6">Inespecífico</Option>
          </Select>
        </div>
        <div className="dn-content">
          {riskFactorList.map((risk) => (
            <div key={risk.id} className="fatores-de-risco-item">
              <p>Fator de risco: {risk.descricao}</p>
              <p>Código: {risk.codigo}</p>
              {risk.epis.map((epi) => (
                <div className="epi" key={epi.id}>
                  <p>EPI: {epi.nome}</p>
                  <p>Código EPI: {epi.id}</p>
                </div>
              ))}
              <Link to="/formulario-epi">
                <Button onClick={() => handleEdit(risk.id)}>Editar</Button>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    userInfo: state.user.userInfo,
    listaEPIsPorGrupo: state.gestorDN.listaEPIsPorGrupo
      ? state.gestorDN.listaEPIsPorGrupo
      : [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    ...bindActionCreators({ getEPIPorGrupo }, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EPIList);
